import React from "react";
import { Sparkles, Music, ShieldCheck, Smartphone, Camera, Activity } from "lucide-react";

/**
 * Infinite horizontal marquee — replaces the centered "Powered by" strip.
 * Two duplicated tracks scroll continuously via CSS keyframes; pause on
 * hover. Designed to read as a premium SaaS "logo wall" without needing
 * real partner logos at v1.
 */
const ITEMS = [
  { Icon: Sparkles,    label: "Claude Sonnet 4.5",  sub: "Anthropic" },
  { Icon: Music,       label: "Spotify Premium",    sub: "Web Playback SDK", color: "text-[#1DB954]" },
  { Icon: Camera,      label: "Claude Vision",      sub: "Photo meal log" },
  { Icon: Activity,    label: "Periodised Plans",   sub: "1–12 week cycles" },
  { Icon: Smartphone,  label: "Native iOS",         sub: "Capacitor + Camera" },
  { Icon: ShieldCheck, label: "Private by design",  sub: "We never sell data" },
];

const Track = ({ ariaHidden = false }) => (
  <div className="flex items-center shrink-0 gap-12 pr-12" aria-hidden={ariaHidden || undefined}>
    {ITEMS.map(({ Icon, label, sub, color }, i) => (
      <div key={`${label}-${i}`} className="flex items-center gap-3 shrink-0">
        <Icon className={`w-4 h-4 ${color || "text-white/55"}`} />
        <div className="leading-tight">
          <div className="text-sm font-medium text-white whitespace-nowrap">{label}</div>
          <div className="text-[10px] uppercase tracking-[0.2em] text-white/35 whitespace-nowrap">{sub}</div>
        </div>
        <span className="w-1 h-1 rounded-full bg-white/15 ml-9" />
      </div>
    ))}
  </div>
);

export default function TickerMarquee() {
  return (
    <section
      className="relative border-b border-white/[0.06] bg-[#0a0a0a] overflow-hidden py-6"
      data-testid="ticker-marquee"
      aria-label="Trusted technologies powering DAIONE"
    >
      {/* Soft edge fade so the loop is seamless */}
      <div className="pointer-events-none absolute inset-y-0 left-0 w-24 z-10 bg-gradient-to-r from-[#0a0a0a] to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-24 z-10 bg-gradient-to-l from-[#0a0a0a] to-transparent" />
      <div className="marquee group">
        <div className="marquee-inner">
          <Track />
          <Track ariaHidden />
        </div>
      </div>
    </section>
  );
}
